module.exports = "/assets/df7004e209cdbdc4af350c481a0e1bf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/MI.png
// module id = 2739
// module chunks = 0